module.exports = __webpack_public_path__ + "img/logo2.f6687434.png";